import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import AdminWorkspaces from "./AdminWorkspaces";

const USERS_API_URL = "https://tu-api.com/users";
const ROLES_API_URL = "https://tu-api.com/roles";

export default function UserRoles() {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [showWorkspacesModal, setShowWorkspacesModal] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [newUser, setNewUser] = useState({
    email: "",
    firstName: "",
    lastName: "",
    role: "",
    active: true,
  });

  useEffect(() => {
    fetchUsers();
    fetchRoles();
  }, []);

  const fetchUsers = async () => {
    const response = await axios.get(USERS_API_URL);
    setUsers(response.data);
  };

  const fetchRoles = async () => {
    const response = await axios.get(ROLES_API_URL);
    setRoles(response.data);
  };

  const handleAddUser = async () => {
    try {
      await axios.post(USERS_API_URL, newUser);
      setNewUser({ email: "", firstName: "", lastName: "", role: "", active: true });
      fetchUsers();
    } catch (error) {
      alert("Error al agregar usuario: " + error.message);
    }
  };

  const handleEditClick = (user) => {
    setSelectedUser(user);
    setShowUserModal(true);
  };

  const handleUserUpdate = async () => {
    try {
      await axios.put(`${USERS_API_URL}/${selectedUser.id}`, selectedUser);
      setShowUserModal(false);
      fetchUsers();
    } catch (error) {
      alert("Error al actualizar usuario: " + error.message);
    }
  };

  return (
    <div className="container mt-4">
      <h1 className="mb-4">Administración de Usuarios y Roles</h1>

      <div className="card mb-4">
        <div className="card-body">
          <h5 className="card-title">Agregar Nuevo Usuario</h5>
          <div className="row g-2">
            <div className="col-md-3">
              <input type="email" className="form-control" placeholder="Correo"
                value={newUser.email} onChange={(e) => setNewUser({ ...newUser, email: e.target.value })} />
            </div>
            <div className="col-md-2">
              <input type="text" className="form-control" placeholder="Nombre"
                value={newUser.firstName} onChange={(e) => setNewUser({ ...newUser, firstName: e.target.value })} />
            </div>
            <div className="col-md-3">
              <input type="text" className="form-control" placeholder="Apellidos"
                value={newUser.lastName} onChange={(e) => setNewUser({ ...newUser, lastName: e.target.value })} />
            </div>
            <div className="col-md-2">
              <select className="form-select" value={newUser.role} onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}>
                <option value="">Seleccionar Rol</option>
                {roles.map((role) => (
                  <option key={role.id} value={role.id}>{role.name}</option>
                ))}
              </select>
            </div>
            <div className="col-md-1 d-flex align-items-center">
              <input type="checkbox" className="form-check-input me-1" checked={newUser.active}
                onChange={(e) => setNewUser({ ...newUser, active: e.target.checked })} />
              <label className="form-check-label">Activo</label>
            </div>
            <div className="col-md-1">
              <button className="btn btn-success w-100" onClick={handleAddUser}>Agregar</button>
            </div>
          </div>
        </div>
      </div>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Correo</th>
            <th>Nombre</th>
            <th>Apellidos</th>
            <th>Rol</th>
            <th>Activo</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              <td>{user.email}</td>
              <td>{user.firstName}</td>
              <td>{user.lastName}</td>
              <td>{roles.find((r) => r.id === user.role)?.name || user.role}</td>
              <td><input type="checkbox" checked={user.active} readOnly /></td>
              <td>
                <button className="btn btn-primary btn-sm me-2" onClick={() => handleEditClick(user)}>Editar</button>
                <button className="btn btn-danger btn-sm">Desactivar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button className="btn btn-secondary" onClick={() => setShowWorkspacesModal(true)}>
        Administrar Workspaces y Reportes
      </button>

      {/* Modal de edición de usuario */}
      {showUserModal && (
        <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Editar Usuario</h5>
                <button type="button" className="btn-close" onClick={() => setShowUserModal(false)}></button>
              </div>
              <div className="modal-body">
                <input type="email" className="form-control mb-2" value={selectedUser.email} onChange={(e) => setSelectedUser({ ...selectedUser, email: e.target.value })} />
                <input type="text" className="form-control mb-2" value={selectedUser.firstName} onChange={(e) => setSelectedUser({ ...selectedUser, firstName: e.target.value })} />
                <input type="text" className="form-control mb-2" value={selectedUser.lastName} onChange={(e) => setSelectedUser({ ...selectedUser, lastName: e.target.value })} />
                <select className="form-select mb-2" value={selectedUser.role} onChange={(e) => setSelectedUser({ ...selectedUser, role: e.target.value })}>
                  {roles.map((role) => (
                    <option key={role.id} value={role.id}>{role.name}</option>
                  ))}
                </select>
                <div className="form-check">
                  <input type="checkbox" className="form-check-input" id="activoCheck" checked={selectedUser.active} onChange={(e) => setSelectedUser({ ...selectedUser, active: e.target.checked })} />
                  <label className="form-check-label" htmlFor="activoCheck">Activo</label>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowUserModal(false)}>Cancelar</button>
                <button className="btn btn-primary" onClick={handleUserUpdate}>Guardar Cambios</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <AdminWorkspaces show={showWorkspacesModal} onClose={() => setShowWorkspacesModal(false)} />
    </div>
  );
}
